<template>
  <div class="main-content">

    <!-- Section: inner-header -->
    <section class="inner-header divider parallax layer-overlay overlay-dark-5 pt-100 bg-image-100-size" data-parallax-ratio="0.7" data-bg-img="images/202208/Sarah94.jpg">
      <div class="container pt-100 pb-30">
        <div class="section-content pt-100">
          <div class="row">
            <div class="col-md-12">
              <h3 class="title text-white">Login</h3>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="loginForm">
      <div class="container pl-50 pr-50">
        <div class="row">
          <div class="col-md-8 col-md-offset-2">
            <h2 class="text-uppercase mt-0 letter-space-3 text-center font-22 mb-20">Accedi ed inizia subito l'<span class="text-theme-colored">allenamento</span></h2>
            <form @submit="clickLogin">
              <div class="row">
                <div class="form-group col-md-12">
                  <label>Email</label>
                  <input type="text" v-model="login.email" class="form-control" />
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12">
                  <label>Password</label>
                  <input type="password" v-model="login.password" class="form-control" />
                </div>
              </div>
              <div class="form-group text-center pt-10">
                <button type="submit" class="btn btn-dark pl-50 pr-50 bg-theme-colored text-white">Accedi</button>

                <p class="mt-20">
                <a
              class="text-theme-colored text-underline"
              href="/resetpass"
              >Hai dimenticato la password?</a
            >
          </p>
                <p v-if="loginFailed" class="text-theme-colored font-12 font-weight-400 pt-10">Login non riuscito! Ricontrolla le tue credenziali.</p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

          
<script>
import store from '../helper/store' // your vuex store

export default {
  name: "Login",
  data() {
    return {
      login: {
        email: "",
        password: ""
      },
      loginFailed: false
    };
  },
  methods: {
    clickLogin: function(e) {
      
        e.preventDefault();
      if (this.login.email != "" && this.login.password != "") {

        const objForLogin =
        {
            identifier: this.login.email.toLowerCase().trim(),
            password: this.login.password
        }

        store.dispatch('login', objForLogin)
          .then(() => {
            //REDIRECT TO DASHBOARD
            window.location.replace("/dashboard");
          })
          .catch(err => {
            this.loginFailed = true;
            console.log(err);
          });
        
      }
    }
  }
};
</script>